import React from "react";
import LoadingIndicator from "../components/LoadingIndicator";

type Props = {};

const PageLoadingComponent = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <LoadingIndicator />
    </div>
  );
};

export default PageLoadingComponent;
